module.exports = __webpack_public_path__ + "img/shanghai doll.aa5bd904.png";